import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://dumbslepwdosoyfhijdh.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR1bWJzbGVwd2Rvc295ZmhpamRoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg3MzM4MjYsImV4cCI6MjA2NDMwOTgyNn0.qnaxqufCoNrj84HWXoWixOD2VHR1l707UW42nhFlWBw'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
